import {fileConfigs} from "./constants";
import {fetch} from "../network";

const _ = fileConfigs;

export function FileController() {

    const upload = async (body) => {

        return new Promise((resolve, reject) => {
            fetch(_.uploadFile.method, _.uploadFile.endpoint, body)
                .then(response => resolve(response.data))
                .catch(error => reject(error.response));
        });
    }

    const download = async (filename) => {

        return new Promise((resolve, reject) => {
            fetch(_.downloadFile.method, _.downloadFile.endpoint + filename, null, {responseType: 'blob'})
                .then(response => resolve(response.data))
                .catch(error => reject(error.response));
        });
    }

    return Object.freeze({
        upload,
        download
    });
}